import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="py-20 bg-white min-h-[60vh]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-gray">
        <h1 className="text-3xl font-serif mb-6 text-gray-900">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: [Current Date]</p>
        
        <p className="mb-4">This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from tatvamretail.in (the "Site").</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">Personal Information We Collect</h2>
        <p>When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">How Do We Use Your Personal Information?</h2>
        <p>We use the Order Information that we collect generally to fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations).</p>
        
        <h2 className="text-2xl font-serif text-[#d4af37] mt-8 mb-4 uppercase tracking-wider">CONTACT US</h2>
        <p className="mb-4">For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at hello@tatvamretail.in or by mail using the details provided below:</p>
        <p className="mb-4 font-semibold">9 Ganesham, Ajmer Road, Shyam Nagar No. 2, Behind Sodhani Sweets, Sodala, Jaipur</p>
      </div>
    </div>
  );
}